module.exports = __webpack_public_path__ + "static/media/company-address-sample-1-preview.f589f428.png";